// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as InfoBlock from "../../resources/layout-and-structure/InfoBlock.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as CatalogProduct from "./CatalogProduct.res.js";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.memo(props => {
  let __displayShopName = props.displayShopName;
  let product = props.product;
  let displayShopName = __displayShopName !== undefined ? __displayShopName : true;
  if (product !== undefined) {
    return JsxRuntime.jsxs(Stack.make, {
      children: [
        displayShopName ? JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("From catalog of") + (" " + product.shopName),
            variation: "normal",
            size: "xxsmall"
          }) : null,
        JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Inside category "),
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: product.formattedCategoryName
            })
          ]
        })
      ]
    });
  } else {
    return null;
  }
});

let OrganisationBlockContent = {
  make: make
};

let make$1 = React.memo(props => {
  let collapsed = props.collapsed;
  let match = Hover.use(undefined, undefined, undefined);
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      collapsed ? null : JsxRuntime.jsx(Box.make, {
          children: props.children,
          spaceTop: "medium"
        }),
      JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Touchable.make, {
          children: JsxRuntime.jsxs(Inline.make, {
            children: [
              JsxRuntime.jsx(LegacyIcon.make, {
                name: collapsed ? "arrow_down_light" : "arrow_up_light"
              }),
              JsxRuntime.jsx(Title.make, {
                children: I18n.t(collapsed ? "Show more" : "Collapse"),
                level: 5,
                weight: "medium",
                color: match[1] ? "#797885" : undefined
              })
            ]
          }),
          onPress: props.onPress,
          ref: match[0]
        }),
        spaceTop: "xsmall"
      })
    ],
    space: "small"
  });
});

let ShowMoreWrapper = {
  make: make$1
};

function CatalogVariantProductInformationCard(props) {
  let shopsProduct = props.shopsProduct;
  let cku = props.cku;
  let match = React.useState(() => false);
  let setShowMore = match[1];
  let scope = Auth.useScope();
  let productPagePathname = CatalogRoutes.productRoute(cku);
  let productCategoryDiffering = React.useMemo(() => CatalogVariant.MultiShops.isReferenceDiffering(shopsProduct, scope, (a, b) => a.formattedCategoryName === b.formattedCategoryName), [
    scope,
    shopsProduct
  ]);
  let product = shopsProduct[0];
  let tmp;
  if (product !== undefined) {
    let match$1 = product.status;
    let tmp$1;
    if (typeof match$1 === "object") {
      let exit = 0;
      if (scope.TAG === "Organisation" && scope.activeShop === undefined) {
        tmp$1 = null;
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp$1 = JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
          value: match$1,
          size: "small"
        });
      }
    } else {
      tmp$1 = null;
    }
    let description = product.description;
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [
        tmp$1,
        JsxRuntime.jsx(TextLink.make, {
          text: product.name,
          to: {
            TAG: "Route",
            _0: CatalogRoutes.productRoute(cku)
          }
        }),
        description !== undefined && description.length > 0 ? JsxRuntime.jsx(TextStyle.make, {
            children: description
          }) : null,
        JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("From "),
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: product.formattedOrigin
            })
          ]
        }),
        JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Default VAT of "),
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: product.taxValue.toString().replace(".", ",") + " %"
            })
          ]
        })
      ],
      space: "xxsmall"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(Card.make, {
    children: [
      tmp,
      JsxRuntime.jsxs(InfoBlock.make, {
        children: [
          JsxRuntime.jsx(make, {
            product: shopsProduct[0],
            displayShopName: productCategoryDiffering
          }),
          productCategoryDiffering ? JsxRuntime.jsx(make$1, {
              children: JsxRuntime.jsx(Stack.make, {
                children: shopsProduct.slice(1).map(product => JsxRuntime.jsx(make, {
                  product: product
                })),
                space: "medium"
              }),
              collapsed: !match[0],
              onPress: param => setShowMore(state => !state)
            }) : null
        ],
        title: "ORGANISATION"
      })
    ],
    title: I18n.t("Bound product"),
    action: {
      icon: "legacy_queue_arrow_right",
      title: I18n.t("See bound product"),
      href: productPagePathname
    }
  });
}

let make$2 = React.memo(CatalogVariantProductInformationCard);

let Config;

export {
  Config,
  OrganisationBlockContent,
  ShowMoreWrapper,
  make$2 as make,
}
/* make Not a pure module */
